import React, {useContext, useState, useEffect} from "react";
import {useLocation, withRouter} from "react-router-dom";
import { css } from "emotion";
import {boxStyles, colors, textSizes} from "../../styles/theme";
import TitleWithBackButton from "../TitleWithBackButton";
import {BuildContext} from "../../context/BuildSpotlightState";
import {GlobalContext} from "../../context/GlobalState";
import GenericButton from "../GenericButton";
import spotlights from "../../services/api/spotlights";

const QueryStringsBody = ({history}) => {
  const query = new URLSearchParams(useLocation().search);
  const {queryParameters, setQueryParameter, setCurrentSpotlight} = useContext(BuildContext);
  const {currentSpotlight, setCurrentSpotlight: setGlobalSpotlight} = useContext(GlobalContext);
  const [focus, setFocus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const lastLocation = query.get('lastLocation');
  const backLocation = `targeting?lastLocation=${lastLocation}`;
  let emptyInput;

  useEffect(() => {
    if (lastLocation === '/view') {
      setCurrentSpotlight(currentSpotlight);
    }
  }, []);

  const setRef = element => {
    emptyInput = element;
  };

  const handleEmptyKeyChange = e => {
    const i = queryParameters.length;
    let queryParameter = {key: '', value: ''};
    queryParameter.key = e.target.value;
    setQueryParameter(queryParameter, i);
    setFocus(i);
    e.target.value = '';
  };

  const handleEmptyValueChange = e => {
    const i = queryParameters.length;
    let queryParameter = queryParameters[i] || {key: '', value: ''};
    queryParameter.value = e.target.value;
    setQueryParameter(queryParameter, i);
    setFocus(i);
    e.target.value = '';
  };

  const handleSaveChanges = async () => {
    if (lastLocation === '/build') {
      history.push(`/${backLocation}`);
    } else {
      setIsLoading(true);
      const {data} = await spotlights.update({queryParameters, id: currentSpotlight.id});
      setGlobalSpotlight(data);
      history.push(`/${backLocation}`);
    }
  };

  return (
    <div className={container}>
      <div className="desktop">
        <TitleWithBackButton title="Query Parameters" backLocation={backLocation} />
      </div>
      <div className="body">
        <form>
          <div className="form-row">
            <label>Query String Parameters</label>
            {queryParameters && queryParameters.map((queryParameter, i) => {
              const handleKeyChange = e => {
                let queryParameter = queryParameters[i];
                queryParameter.key = e.target.value;
                setQueryParameter(queryParameter, i);

                if (queryParameters[i].key === '' && queryParameters[i].value === '') {
                  emptyInput.focus();
                }
              };

              const handleValueChange = e => {
                let queryParameter = queryParameters[i];
                queryParameter.value = e.target.value;
                setQueryParameter(queryParameter, i);

                if (queryParameters[i].key === '' && queryParameters[i].value === '') {
                  emptyInput.focus();
                }
              };

              return (
                <div className="query-params" key={`query-${i}`}>
                  <input placeholder='key' value={queryParameter.key} onChange={handleKeyChange} autoFocus={focus === i} />
                  <span>=</span>
                  <input placeholder='value' value={queryParameter.value} onChange={handleValueChange} />
                </div>
              );
            })}
            <div className="query-params">
              <input ref={setRef} placeholder='key' onChange={handleEmptyKeyChange} autoFocus={queryParameters && queryParameters.length < 1} />
              <span>=</span>
              <input placeholder='value' onChange={handleEmptyValueChange} />
            </div>
          </div>

          <GenericButton
            text="SAVE CHANGES"
            handleClick={handleSaveChanges}
            disabled={isLoading}
            style={button}
          />
        </form>
      </div>
    </div>
  );
};

export default withRouter(QueryStringsBody);

const container = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .desktop {
    display: none;
  }
  
  .body {
    display: flex;
    justify-content: center;
    padding: 10px;
    margin-top: 15px;
    
    form {
      max-width: 600px;
      width: 100%;
    }
  }
  
  .form-row {
    display: flex;
    flex-direction: column;
  }
  
  .query-params {
    align-items: center;
    display: flex;
    margin-bottom: 15px;
    
    span {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  
  label {
    font-size: 12px;
    color: #191919;
    padding-bottom: 10px;
    font-weight: 500;
    letter-spacing: 1px;
  }
  
  input {
    background-color: ${colors.inputBackground};
    border: none;
    border-radius: 8px;
    padding: ${boxStyles.standardPadding};
    color: ${colors.inputTextColor};
    flex: 1;
    font-size: ${textSizes.normal};
    min-width: 0;

    &::placeholder {
      color: ${colors.placeholderText};
    }
  }
  
  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .desktop {
      display: initial;
    }
    
    .body {
      padding: 30px;
    }
  }
`;

const button = css`
  width: auto;
  min-width: 180px;
  padding-left: 20px;
  padding-right 20px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
`;
